import Grid from "@mui/material/Grid";
import { OverviewCard } from "../shared/components/OverviewCard";
import { useNavigate } from "react-router-dom";
import { PageContainer } from "../shared/components/PageContainer";
import { useEffect, useState } from "react";
import { useFetchContext } from "../../contexts/FetchContext";
import { useOrderContext } from "../../contexts/OrderContext";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Stack,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import { FlipToFront } from "@mui/icons-material";

const initialContantore = {
  ACCETTAZIONI: 0,
  ORDINI: 0,
};

export const Dashboard = () => {
  const navigate = useNavigate();
  const { fetchData } = useFetchContext();
  const orders = useOrderContext();

  const [contatore, setContantore] = useState(initialContantore);
  const [modalOpen, setModalOpen] = useState(false);
  const [locationValue, setLocationValue] = useState("");
  const [locationSerialNumberValue, setLocationSerialNumberValue] =
    useState("");
  const [totalModalOpen, setTotalModalOpen] = useState(false);
  const [totalLocationValue, setTotalLocationValue] = useState("");
  const [totalProductCodeValue, setTotalProductCodeValue] = useState("");

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        const response = await fetchData(
          `/documents?pageSize=1&page=1&type=ACCEPTANCE&status=OPEN`
        );

        const response2 = await fetchData(
          `/documents?pageSize=1&page=1&type=DISPATCH&status=OPEN`
        );

        setContantore({
          ...contatore,
          ACCETTAZIONI: response?.data?.total,
          ORDINI: response2?.data?.total,
        });
      } catch (error) {}
    };

    fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setLocationValue("");
    setLocationSerialNumberValue("");
  };

  const handleOpenTotalModal = () => {
    setTotalModalOpen(true);
  };

  const handleCloseTotalModal = () => {
    setTotalModalOpen(false);
    setTotalLocationValue("");
    setTotalProductCodeValue("");
  };

  const handleTotalLocationModalSubmit = async () => {
    try {
      if (totalProductCodeValue && totalLocationValue) {
        const payload = {
          productCode: totalProductCodeValue,
          warehouseLocation: totalLocationValue,
        };

        const response = await fetchData(
          "/products/set-total-location",
          "POST",
          payload
        );

        if (response.data.affected > 0) {
          toast.success(`Prodotti ubicati: ${response.data.affected}`);
        } else {
          toast.error("Operazione fallita: " + response?.data?.message);
        }

        handleCloseTotalModal();
        document.getElementById("search")?.focus();
      }
    } catch (error: any) {
      toast.error("Operazione fallita: " + (error?.message ?? error));
      console.error("Error submitting modal data:", error);
    }
  };

  const handleLocationModalSubmit = async () => {
    try {
      if (locationSerialNumberValue && locationValue) {
        const payload = {
          serialNumber: locationSerialNumberValue,
          warehouseLocation: locationValue,
        };

        const response = await fetchData(
          "/products/set-location",
          "POST",
          payload
        );

        if (response.data.affected > 0) {
          toast.success(`Prodotti ubicati: ${response.data.affected}`);
        } else {
          toast.error("Operazione fallita: " + response?.data?.message);
        }

        handleCloseModal();
        document.getElementById("search")?.focus();
      }
    } catch (error: any) {
      toast.error("Operazione fallita: " + (error?.message ?? error));
      console.error("Error submitting modal data:", error);
    }
  };

  return (
    <PageContainer>
      <Grid item xs={12} mb={4}>
        <OverviewCard
          sx={{ height: "100%", cursor: "pointer" }}
          value={contatore.ACCETTAZIONI}
          title="Accettazioni"
          backgroundIcon="red"
          onClick={() => navigate("/documents?type=ACCEPTANCE&status=OPEN")}
        />
      </Grid>
      <Grid item xs={12} mb={4}>
        <OverviewCard
          sx={{ height: "100%", cursor: "pointer" }}
          value={orders && orders > 0 ? orders : contatore.ORDINI}
          title="Ordini"
          backgroundIcon="#8BC34A"
          onClick={() => navigate("/documents?type=DISPATCH&status=OPEN")}
        />
      </Grid>
      <Grid item xs={12} mb={4}>
        <OverviewCard
          icon={<FlipToFront />}
          sx={{ height: "100%", cursor: "pointer" }}
          title="Cambia Ubicazione"
          backgroundIcon="#f5df1f"
          onClick={handleOpenModal}
        />
      </Grid>
      <Grid item xs={12} mb={4}>
        <OverviewCard
          icon={<FlipToFront />}
          sx={{ height: "100%", cursor: "pointer" }}
          title="Ubicazione Totale Prodotto"
          backgroundIcon="#03a9f4"
          onClick={handleOpenTotalModal}
        />
      </Grid>

      <Modal disableEnforceFocus open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Inserisci ubicazione
          </Typography>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleLocationModalSubmit();
            }}
          >
            <TextField
              fullWidth
              autoFocus
              label="Matricola"
              value={locationSerialNumberValue}
              onChange={(e) => setLocationSerialNumberValue(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  document.getElementById("ubicazione")?.focus();
                }
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              id="ubicazione"
              label="Ubicazione"
              value={locationValue}
              onChange={(e) => setLocationValue(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="outlined" onClick={handleCloseModal}>
                Cancella
              </Button>
              <Button
                variant="contained"
                type="submit"
                disabled={!locationValue || !locationSerialNumberValue}
              >
                Conferma
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>

      <Modal
        disableEnforceFocus
        open={totalModalOpen}
        onClose={handleCloseTotalModal}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Ubicazione totale prodotto
          </Typography>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleTotalLocationModalSubmit();
            }}
          >
            <TextField
              fullWidth
              autoFocus
              label="Codice Prodotto"
              value={totalProductCodeValue}
              onChange={(e) => setTotalProductCodeValue(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  document.getElementById("ubicazione-totale")?.focus();
                }
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              id="ubicazione-totale"
              label="Ubicazione"
              value={totalLocationValue}
              onChange={(e) => setTotalLocationValue(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="outlined" onClick={handleCloseTotalModal}>
                Cancella
              </Button>
              <Button
                variant="contained"
                type="submit"
                disabled={!totalLocationValue || !totalProductCodeValue}
              >
                Conferma
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>
    </PageContainer>
  );
};
